import { jsx } from "react/jsx-runtime";
import { useAdBreakList } from "../../../../VideoContextProvider/context/state/adBreakList.js";
import { toPercentage } from "../../../../../lib/videoUtils.js";
/* empty css           */
function AdMarkerPoints({ min, max }) {
  const adBreakList = useAdBreakList();
  const adMarkerPoints = adBreakList.filter((ad) => ad.type === "Midroll").map((ad) => ad.position);
  if (adMarkerPoints.length === 0) {
    return null;
  }
  return /* @__PURE__ */jsx("div", { className: "omega_adsWrapper", "data-testid": "adMarkers", children: adMarkerPoints.map(
      (point) => point && /* @__PURE__ */jsx(
        "div",
        {
          className: "omega_adsMarker",
          style: { left: `${toPercentage(point, min, max)}%` }
        },
        point
      )
    ) });
}
export {
  AdMarkerPoints };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/Slider/AdMarkerPoints/index.js.map